module.exports = __webpack_public_path__ + "static/media/Hover1_ New York.23d92f67.jpg";